import {FC, useEffect} from 'react'
import {Dispatch} from 'redux'
import clsx from 'clsx'
import {useLocation} from 'react-router-dom'
import {CompanySwitchMenu, HeaderNotificationsMenu, HeaderUserMenu} from '../../../partials'
import {shallowEqual, useDispatch, useSelector} from 'react-redux'
import {RootState} from '../../../../setup'
import {getInitials} from '../../../../app/services/Functional'
import {KTSVG} from '../../../helpers'
import {QueryResponseProvider} from '../../../../app/modules/notifications/notifications-list/core/QueryResponseProvider'
import {QueryRequestProvider} from '../../../../app/modules/notifications/notifications-list/core/QueryRequestProvider'
import {ListViewProvider} from '../../../../app/modules/notifications/notifications-list/core/ListViewProvider'
import {getNotificationList} from '../../../../setup/redux/notifications/actions'
import CustomTooltip from '../../../tooltip/CustomTooltip'
import {handleArrivedFromTheScheduleModule} from '../../../../setup/redux/frequencies/actions'

const toolbarButtonMarginClass = 'ms-1 ms-lg-3',
  toolbarButtonHeightClass = 'w-30px h-30px w-md-40px h-md-40px',
  toolbarUserAvatarHeightClass = 'symbol-30px symbol-md-40px',
  toolbarButtonIconSizeClass = 'svg-icon-1'

const NotificationsList = () => {
  const dispatch: Dispatch<any> = useDispatch()
  const {pathname} = useLocation()
  const {totalUnreadNotificationCount, notifications}: any = useSelector<RootState>(
    (state) => ({
      totalUnreadNotificationCount: state.notifications.totalUnreadNotificationCount,
      notifications: state.notifications.notifications,
    }),
    shallowEqual
  )

  const fetchNotificationData = () => {
    dispatch(getNotificationList())
    if (!pathname.includes('/schedule')) {
      dispatch(handleArrivedFromTheScheduleModule(false))
    }
  }

  useEffect(() => {
    fetchNotificationData()
    const interval = setInterval(fetchNotificationData, 300000)
    return () => clearInterval(interval)
  }, [])

  return (
    <>
      <div className={clsx('d-flex align-items-center', toolbarButtonMarginClass)}>
        {/* begin::Menu- wrapper */}
        <div
          className={clsx(
            'btn btn-icon btn-active-light-primary btn-custom position-relative notificationBell',
            toolbarButtonHeightClass
          )}
          data-kt-menu-trigger='click'
          data-kt-menu-attach='parent'
          data-kt-menu-placement='bottom-end'
          data-kt-menu-flip='bottom'
        >
          <KTSVG
            path='/media/icons/duotune/general/gen007.svg'
            className={toolbarButtonIconSizeClass}
          />
          {totalUnreadNotificationCount ? (
            <span className=' translate-middle badge badge-circle badge-danger px-3'>
              {totalUnreadNotificationCount}
            </span>
          ) : (
            ''
          )}
        </div>
        <HeaderNotificationsMenu notifications={notifications} />
        {/* end::Menu wrapper */}
      </div>
    </>
  )
}

const Topbar: FC = () => {
  const {user, active_inspection_company, inspectionCompanies}: any = useSelector<RootState>(
    (state) => ({
      user: state.auth.user,
      inspectionCompanies: state.auth.inspection_companies,
      active_inspection_company: state.auth.active_inspection_company,
    }),
    shallowEqual
  )

  return (
    <div className='d-flex align-items-stretch flex-shrink-0'>
      {/* COMPANY LIST */}
      <div
        className={clsx('d-flex align-items-center', toolbarButtonMarginClass)}
        id='kt_header_comoany_menu_toggle'
      >
        <div
          className={`cs-btn d-flex align-items-center justify-content-between ${inspectionCompanies.length > 1 && 'cursor-pointer cs-btn-hover'}`}
          data-kt-menu-trigger='click'
          data-kt-menu-attach='parent'
          data-kt-menu-placement='bottom-end'
          data-kt-menu-flip='bottom'
        >
          <div className='d-flex flex-gap-8 align-items-center'>
            <span className='sc-logo'>
              {active_inspection_company?.logo ? (
                <img alt='Logo' src={active_inspection_company?.logo} className='sc-company-logo' />
              ) : (
                <KTSVG
                  path='/media/icons/duotune/general/building.svg'
                  svgClassName='list-svg'
                  svgIconClassnameApply={false}
                />
              )}
            </span>
            <span className='sc-selected-com font-size-14 font-weight-bold line-height-22 text-dark-indigo d-flex align-items-center justify-content-center'>
              {active_inspection_company?.name}
            </span>
          </div>
          {inspectionCompanies.length > 1 && (
            <KTSVG path='/media/icons/duotune/arrows/list-arrow.svg' svgClassName='list-svg' />
          )}
        </div>
        {inspectionCompanies.length > 1 && <CompanySwitchMenu />}
      </div>
      {/* NOTIFICATIONS */}
      <QueryRequestProvider>
        <QueryResponseProvider>
          <ListViewProvider>
            <NotificationsList />
          </ListViewProvider>
        </QueryResponseProvider>
      </QueryRequestProvider>
      {/* USER PROFILE MENU */}
      <div
        className={clsx('d-flex align-items-center', toolbarButtonMarginClass)}
        id='kt_header_user_menu_toggle'
      >
        <div
          className={clsx('cursor-pointer symbol d-flex flex-gap-12', toolbarUserAvatarHeightClass)}
          data-kt-menu-trigger='click'
          data-kt-menu-attach='parent'
          data-kt-menu-placement='bottom-end'
          data-kt-menu-flip='bottom'
        >
          {user && (
            <>
              {user.avatar ? (
                <img alt='Logo' src={user.avatar} />
              ) : (
                <div className='symbol-label fs-3 bg-light-primary text-primary'>
                  {getInitials(user.name)}
                </div>
              )}
              <div className='d-none d-md-flex flex-column justify-content-between'>
                <div className='font-size-16 line-height-22 font-weight-SemiBold text-dark-indigo topbar-user-name'>
                  {user.name}
                </div>
                {user.is_root ? (
                  <span className='font-size-12 line-height-18 font-weight-regular text-lavender-gray'>
                    Role: Decent Super-Admin
                  </span>
                ) : active_inspection_company?.groups?.length > 0 ? (
                  <span className='font-size-12 line-height-18 font-weight-regular text-lavender-gray'>
                    Role: {active_inspection_company.groups[0]?.name}
                    {active_inspection_company.groups?.length >= 2 && (
                      <CustomTooltip
                        key='user-role-tooltip'
                        message={
                          active_inspection_company.groups
                            ?.slice(1)
                            ?.map((group: any) => group.name)
                            ?.join(', ') || ''
                        }
                        position='bottom'
                      >
                        {' '}
                        <span className='text-primary'>
                          +{active_inspection_company.groups.length - 1}
                        </span>
                      </CustomTooltip>
                    )}
                  </span>
                ) : null}
              </div>
            </>
          )}
        </div>
        <HeaderUserMenu />
      </div>
    </div>
  )
}

export {Topbar}
